import { createWebHashHistory, createRouter } from 'vue-router';
import moduleAuth from '@/routes/module/auth';
import moduleSetting from '@/routes/module/setting';
import moduleGuide from '@/routes/module/guide';
import moduleStudyStatus from '@/routes/module/study-status';
import moduleSupport from '@/routes/module/support'
import moduleSearchGuide from '@/routes/module/search'
import moduleInquiry from '@/routes/module/inquiry'
import moduleSchool from '@/routes/module/school';

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior () {
    return { top: 0 }
  },

  // pages
  routes: [
    {
      path: '/',
      redirect: { name: 'loginApp' },
    },
    {
      path: '/main',
      name: 'mainApp',
      component: () => import(/* webpackChunkName: "mainApp" */'@/views/main/main-app'),
      children: [
        {
          path: 'study',
          name: 'mainStudyTab',
          component: () => import(/* webpackChunkName: "mainStudyTab" */'@/views/main/comp/main-superv-tap'),
        },
        {
          path: 'books',
          name: 'mainBooksTab',
          component: () => import(/* webpackChunkName: "mainBooksTab" */'@/views/main/comp/main-superbooks-tap'),
        },
      ]
    },
    ...moduleAuth,
    ...moduleSetting,
    ...moduleGuide,
    ...moduleStudyStatus,
    ...moduleSupport,
    ...moduleSearchGuide,
    ...moduleInquiry,
    ...moduleSchool
  ]
});

router.onError((error) => {
  if (error.name === 'ChunkLoadError') {
    window.location.reload();
  }
})
export default router;
